import React from 'react';

function WaterTrackPrivacy() {
  return (
    <div className="water-track-privacy-page">
      <section className="privacy-hero">
        <div className="container">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-subtitle">Water Track Daily H2O</p>
          <p className="privacy-subtitle">Last updated: September 23, 2025</p>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-text">
            <div className="privacy-section">
              <h2>Key Points</h2>
              <p>
                <ul>
                  <li>Your data stays on your device stored in a local database</li>
                  <li>No ads, no tracking, no thid-party analytics services</li>
                  <li>Notifications are optional and can be managed in app or via your system settings</li>
                  <li>Delete your data anytime from the in app settings or by uninstalling the app.</li>
                </ul>
              </p>
            </div>

            <div className="privacy-section">
              <h2>1. Introduction</h2>
              <p>
                Welcome to Water Track Daily H2O. This Privacy Policy explains how we collect, use, and protect your information 
                when you use our mobile application. We are committed to protecting your privacy and ensuring the security of your data.
              </p>
            </div>

            <div className="privacy-section">
              <h2>2. Information We Collect</h2>
              <p>
                <strong>Local Data Only:</strong> Water Track Daily H2O stores all your hydration data locally on your device. 
                We do not collect, transmit, or store any personal information on our servers.
              </p>
              <p>
                The app may collect the following data locally on your device:
              </p>
              <ul>
                <li>Daily water intake logs</li>
                <li>Personal hydration goals</li>
                <li>Reminder preferences</li>
                <li>App settings and preferences</li>
              </ul>

              <h3>2.2 Automatically Collected Information</h3>
              <p>We do not collect analytics and crash reports beyond what the iOS App Store or Google Play Store may provide automatically at a platform level.</p>
            </div>

            <div className="privacy-section">
              <h2>3. How We Use Your Information</h2>
              <p>
                Since all data is stored locally on your device, we do not have access to or use your personal information. 
                The app uses your local data solely to:
              </p>
              <ul>
                <li>Track your daily hydration progress</li>
                <li>Display historical data and trends</li>
                <li>Send local notifications for reminders</li>
                <li>Provide personalized recommendations</li>
              </ul>
              <p>
              <strong>Siri Shortcuts and Voice Integration</strong>
              <p>Water Track Daily H₂O now supports Apple Siri Shortcuts to allow convenient logging of water intake and, in the future, to report your daily total.</p>
              <li>All Siri interactions are processed by Apple's Siri service on your device.</li>
              <li>No Siri voice data or related information is transmitted to or stored on our servers.</li>
              <li>Water intake amounts remain stored locally on your device as described elsewhere in this policy.</li>
              </p>
            </div>

            <div className="privacy-section">
              <h2>4. Data Storage and Security</h2>
              <p>
                <strong>Local Storage:</strong> All your water intake data and personal settings are stored locally on your device 
                using secure local storage. This means your data never leaves your device unless you explicitly choose to back it up. If you backup your device this data may be included in the device backup.
              </p>
              <p>
                <strong>No Cloud Storage:</strong> We do not use cloud services or external servers to store your data.
              </p>
              <p>
                <strong>Device Security:</strong> Your data is protected by your device's security measures, including 
                device locks, encryption, and other security features you have enabled.
              </p>
            </div>

            <div className="privacy-section">
              <h2>5. Data Sharing</h2>
              <p>
                <strong>We do not share your data</strong> because we do not have access to it. All data remains on your device.
              </p>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to third parties.
              </p>
            </div>

            <div className="privacy-section">
              <h2>6. Third-Party Services</h2>
              <p>
                Water Track Daily H2O may use the following third-party services:
              </p>
              <ul>
                <li><strong>Device Notifications:</strong> For sending reminders (uses your device's notification system if enabled by you)</li>
                <li><strong>Basic App Store Analytics:</strong> Basic usage statistics provided by the app store (iOS App Store/Google Play)</li>
              </ul>
              <p>
                These services have their own privacy policies, and we encourage you to review them.
              </p>
            </div>

            <div className="privacy-section">
              <h2>7. Children's Privacy</h2>
              <p>
                Our app is suitable for users of all ages. Since we do not collect any personal information, 
                there are no special considerations for children's privacy.
              </p>
            </div>

            <div className="privacy-section">
              <h2>8. Your Rights</h2>
              <p>
                Water Track Daily H2O does not collect personal identifiers. This app is not intended for use by children.
              </p>
              <ul>
                <li>You can delete the app to remove all data</li>
                <li>You can clear app data through your device settings</li>
                <li>You can export or backup your data if the app provides such features</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2>9. Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
                the new Privacy Policy in the app and updating the "Last updated" date. You are advised to review 
                this Privacy Policy periodically for any changes.
              </p>
            </div>

            <div className="privacy-section">
              <h2>10. Contact Information</h2>
              <p>
                If you have any questions about this Privacy Policy or our data practices, please contact us:
              </p>
              <div className="contact-info-privacy">
                <p><strong>Developer:</strong> Cary Schweitzer</p>
                <p><strong>Contact:</strong> <a href="/contact">Contact Page</a></p>
                <p><strong>Company:</strong> Cary Schweitzer</p>
              </div>
            </div>

            <div className="privacy-section">
              <h2>11. Governing Law</h2>
              <p>
                This Privacy Policy is governed by and construed in accordance with the laws of Texas, United States. 
                Any disputes arising from this Privacy Policy will be subject to the exclusive jurisdiction of the
                courts of Texas.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WaterTrackPrivacy;